import client from "./client";

/* ---------------- CERTIFICATE TYPES ---------------- */

// Get all certificate types (static config)
export const getCertificateTypes = () =>
  client.get("/certificates/types").then((res) => res.data);

/* ---------------- USER DASHBOARD ---------------- */

// 🔹 Get logged-in user's certificates
export const getMyCertificates = () =>
  client.get("/certificates/my").then((res) => res.data);

/* ---------------- CERTIFICATE ISSUING ---------------- */

// 🔹 Issue a certificate (admin / system)
export const issueCertificate = (payload) =>
  client.post("/certificates/issue", payload).then((res) => res.data);

/* ---------------- VERIFICATION ---------------- */

// 🔹 Verify certificate by serial (public)
export const verifyCertificate = (certificateSerial) =>
  client
    .get(`/certificates/verify/${certificateSerial}`) // Matches router.get("/verify/:serial")
    .then((res) => res.data);
